import FileImporter from './importer';

export default {
    __init__ : [ 'importSchema'],
    importSchema: ['type', FileImporter ]
}